
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/assembly",
      function () {
        return require("private-next-pages/help/assembly.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/assembly"])
      });
    }
  